/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import SwalToast from '../components/Common/SwalToast';
import { API_ENDPOINTS } from '../const/ApiEndpoints';

const logout = () => {
  try {
    localStorage.clear();
    window.location.reload();
    window.KEYCLOAK_CONFIG.logout();
  } catch (e) {
    console.log(e);
  }
};
function containInApiList(targetString) {
  const endpointValues = Object.values(API_ENDPOINTS);
  return endpointValues?.some((endpoint) => targetString?.includes(endpoint));
}
export const initializeAxiosForKeycloak = () => {
  let headersCommonOptions = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  let showLoaderEvent = new Event('showLoader', { bubbles: true });
  let hideLoaderEvent = new Event('hideLoader', { bubbles: true });
  let numberOfApiCallsPending = 0;
  axios.defaults.baseURL = API_ENDPOINTS.DJANGO_SERVER_ADDRESS;
  axios.defaults.headers.common = headersCommonOptions;
  axios.interceptors.request.use((req) => {
    // `req` is the Axios request config, so you can modify
    // the `headers`.

    const token = localStorage.getItem('token');
    if (token) {
      if (!containInApiList(req.url)) {
        delete req.headers.Authorization;
      } else {
        req.headers.Authorization = `Bearer ${token}`;
      }
    }
    const org = localStorage.getItem('org');
    if (org) {
      req.headers.org = org;
    }
    numberOfApiCallsPending++;
    if (req?.loader == false || req?.data?.loader == false) {
      document.dispatchEvent(hideLoaderEvent);
    } else {
      document.dispatchEvent(showLoaderEvent);
    }
    return req;
  });

  axios.interceptors.response.use(
    (response) => {
      numberOfApiCallsPending--;
      if (numberOfApiCallsPending === 0) {
        setTimeout(() => {
          document.dispatchEvent(hideLoaderEvent);
        }, 400);
      }
      return response;
    },
    async (error) => {
      numberOfApiCallsPending--;
      if (numberOfApiCallsPending === 0) {
        setTimeout(() => {
          document.dispatchEvent(hideLoaderEvent);
        }, 400);
      }
      const errorMessage = error?.response?.data?.Msg
        ? typeof error?.response?.data?.Msg === 'string'
          ? error.response.data.Msg
          : JSON.stringify(error.response.data.Msg)
        : error.message;

      if (error.response?.status === 403 && !error?.config?._retry) {
        error.config._retry = true;

        try {
          if (window.KEYCLOAK_CONFIG.isTokenExpired()) {
            console.log('Token expired. Trying to refresh...');
            // SwalToast({
            //   icon: 'info',
            //   title: 'Token expired. Refreshing and resending request.',
            // });

            try {
              await window.KEYCLOAK_CONFIG.updateToken(2);
              const newToken = window.KEYCLOAK_CONFIG.token;

              if (newToken) {
                localStorage.setItem('token', newToken);
                // SwalToast({
                //   icon: 'success',
                //   title:
                //     'Token refreshed successfully. Resending API requests.',
                // });

                // Only set default Authorization header for API endpoints

                if (containInApiList(error.config.url)) {
                  error.config.headers.Authorization = `Bearer ${newToken}`;
                } else {
                  // For non-API endpoints, ensure Authorization header is removed
                  delete error.config.headers.Authorization;
                }

                return axios.request(error.config);
              }
            } catch (refreshError) {
              // Ensure logout always happens if token refresh fails
              SwalToast({
                icon: 'warning',
                title:
                  'Your session has expired. Please log in to continue using our services.',
              });
              logout();
              return Promise.reject(error);
            }
          }

          return Promise.reject(error);
        } catch (tokenRefreshError) {
          // SwalToast({
          //   icon: 'error',
          //   title: 'Failed to refresh the token.',
          // });
          logout(); // Ensuring logout happens on error
          return Promise.reject(error);
        }
      }

      if (error.response?.data?.Msg) {
        SwalToast({
          icon: 'error',
          title: errorMessage,
        });
      }
      return Promise.reject(error);
    }
  );
};

// export default intializeAxiosForKeycloak;
